import { Button } from '@design-system/components/button/button';
import { Modal, PlainModalProps } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';
import BuilderExerciseType from '../../../../../../static/images/builder/builder-exercise-selection.png';

export const ExerciseTypesInfoModal = ({
  isOpen,
  onClose,
}: Pick<PlainModalProps, 'isOpen' | 'onClose'>) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Build Your Perfect Workout! 💪"
      modalClassName="w-full md:max-w-[700px]"
      contentClassName="py-10.5 px-8"
      titleClassName="text-[36px]"
      centerContent
      largeTitle
    >
      <div className="flex flex-col gap-6">
        <div className="flex flex-col">
          <Typography variant="body" size="large" fontWeight="normal">
            🎥 Browse your video library to pick your favorite exercises.
          </Typography>
          <Typography variant="body" size="large" fontWeight="normal">
            Then, add your reps, sets, rest time.
          </Typography>
        </div>
        <img src={BuilderExerciseType} />
        <Typography variant="body" size="large" fontWeight="normal">
          Ready? Let’s get started and make every rep count! 🚀
        </Typography>
        <div className="flex flex-col md:flex-row gap-6 justify-center items-center">
          <a
            href="https://help.playbookapp.io/en/collections/9730965-build-programs-workouts"
            target="_blank"
            rel="noreferrer"
          >
            <Button variant="text" className="w-[210px]" onClick={onClose}>
              Guide me more
            </Button>
          </a>
          <Button color="neutral" className="w-[210px]" onClick={onClose}>
            Ok, got it
          </Button>
        </div>
      </div>
    </Modal>
  );
};
